import DatabaseModel from './DatabaseModel.js';
import CacheService from './Cache.js';

var Tarifa = Object.create(DatabaseModel);
Tarifa.model = 'tarifas';
Tarifa.modelFront = 'tarifas';

Tarifa.activar = function(params) {
    var self = this;
    params = params || {};
    if (!params.itemId) return Promise.reject({ error: 'itemId not defined' });
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/' + params.itemId + '/activar',
        method: 'PUT',
        data: params.data || {}
    };
    return self.sendRequest(request, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};

Tarifa.anular = function(params) {
    var self = this;
    params = params || {};
    if (!params.itemId) return Promise.reject({ error: 'itemId not defined' });
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/' + params.itemId + '/anular',
        method: 'PUT',
        data: params.data || {}
    };
    return self.sendRequest(request, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};

Tarifa.getConfig = function(forceReload) {
    var self = this;
    var request = {
        url: self.server_movilidad + self.prefix + 'tarifas/config-global/',
        method: 'GET',
        data: {}
    };
    return self.sendRequest(request, !forceReload);
};

Tarifa.updateConfig = function(params) {
    var self = this;
    params = params || {};
    var request = {
        url: self.server_movilidad + self.prefix + 'tarifas/config-global/',
        method: 'PUT',
        data: params.data || {}
    };
    return self.sendRequest(request, false);
};

Tarifa.calcular = function(dto) {
    var self = this;
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/calcular',
        method: 'POST',
        data: dto
    };
    return self.sendRequest(request, false);
};

Tarifa.calcularYGuardar = function(dto) {
    var self = this;
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/calcular-y-guardar',
        method: 'POST',
        data: dto
    };
    return self.sendRequest(request, false);
};

Tarifa.getConfigHistorial = function(filtros) {
    var self = this;
    filtros = filtros || {};
    var queryParams = [];
    if (filtros.herramientaCodigo) queryParams.push('herramientaCodigo=' + filtros.herramientaCodigo);
    if (filtros.fechaDesde) queryParams.push('fechaDesde=' + filtros.fechaDesde);
    if (filtros.fechaHasta) queryParams.push('fechaHasta=' + filtros.fechaHasta);
    var qs = queryParams.length ? '?' + queryParams.join('&') : '';
    var request = {
        url: self.server_movilidad + self.prefix + 'tarifas/config-global/historial' + qs,
        method: 'GET',
        data: {}
    };
    return self.sendRequest(request, false);
};

Tarifa.updateConfigConHerramientas = function(params) {
    var self = this;
    params = params || {};
    var request = {
        url: self.server_movilidad + self.prefix + 'tarifas/config-global/aplicar',
        method: 'PUT',
        data: params.data || {}
    };
    return self.sendRequest(request, false);
};

Tarifa.getHerramientas = function() {
    var self = this;
    var request = {
        url: self.server_movilidad + self.prefix + 'tarifa-herramientas/',
        method: 'GET',
        data: {}
    };
    return self.sendRequest(request, false);
};

Tarifa.getTodasHerramientas = function() {
    var self = this;
    var request = {
        url: self.server_movilidad + self.prefix + 'tarifa-herramientas/todas',
        method: 'GET',
        data: {}
    };
    return self.sendRequest(request, false);
};

Tarifa.buscarHerramientas = function(filtros) {
    var self = this;
    filtros = filtros || {};
    var queryParams = [];
    if (filtros.codigo) queryParams.push('codigo=' + filtros.codigo);
    if (filtros.activo !== undefined && filtros.activo !== '') queryParams.push('activo=' + filtros.activo);
    if (filtros.fechaDesde) queryParams.push('fechaDesde=' + filtros.fechaDesde);
    if (filtros.fechaHasta) queryParams.push('fechaHasta=' + filtros.fechaHasta);
    var qs = queryParams.length ? '?' + queryParams.join('&') : '';
    var request = {
        url: self.server_movilidad + self.prefix + 'tarifa-herramientas/buscar' + qs,
        method: 'GET',
        data: {}
    };
    return self.sendRequest(request, false);
};

export default Tarifa;
